module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TAlcrS/media/FC-9781398478428.jpg?1718046516834",
      "alt": "This image is the cover for the book The Bremen Singers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Bremen Singers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Rooster, Cat, Dog and Donkey must flee their homes, they feel afraid and alone in the world. They meet on the road and are surprised to find others in a similar situation. They quickly become friends. The rooster has the idea of going to Bremen to become a busker, since he has such a good voice. The others assure him that they, too, are musical, with good singing voices, and form a quartet! On the way to Bremen, they spy a house, off-road, in the forest. They had just been thinking about shelter for the night. Maybe they can sing for their supper, too. But the house is the hideout of a gang of robbers, who are not likely to welcome passing travellers. How is it, then, that the four friends are able to take possession of the house, and live there, peacefully, for a while? Suddenly, everything changes when visitors arrive. Is it for the better?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Moira Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Moira Brown is a retired teacher, living in Newcastle, Australia. The idea of writing The Bremen Singers came from taking her grandchildren to the local Young People’s Theatre, and from buying some photographs of Bremen, which now hang on a wall in her home. Thus the work started off as a play, then a musical, before it was put into book form.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0